export const serialize = (data: object): string => {
    let s;
    try {
        s = encodeURIComponent(JSON.stringify(data));
    } catch (_) {
        s = '';
    }
    return s;
};

export const unserialize = (data: string | object): object => {
    let o;
    try {
        o = typeof data === 'string' ? JSON.parse(decodeURIComponent(data)) : data;
    } catch (_) {
        o = {};
    }
    return o;
};

export const applyOptions = (component: { options?: object | string }) => {
    const options = unserialize(component.options);
    Object.assign(component, options);
};
